import { ReactNode, ReactElement, useState } from 'react'
import styled from 'styled-components'
import { MessageBoxTitleBar } from './MessageBoxTitleBar'
import { MessageBoxType } from '../Interfaces'

interface MessageBoxProps {
  title: string
  titleReplacement?: Array<string | number>
  closeText?: string
  children: ReactNode
  show: boolean
  type?: MessageBoxType
}

export const MessageBox = (props: MessageBoxProps): ReactElement | null => {
  const {
    title,
    titleReplacement,
    closeText = 'dismiss',
    children,
    show,
    type = MessageBoxType.WARNING,
  } = props
  const [showMessage, setShowMessage] = useState(show)
  if (!showMessage) {
    return null
  }
  const isErrorTypeOfUnavaliabilty = MessageBoxType.ERROR === type

  return (
    <MessagesBoxWrapper isErrorTypeOfUnavaliabilty={isErrorTypeOfUnavaliabilty}>
      <MessageBoxTitleBar
        titleText={title}
        titleReplacement={titleReplacement}
        closeText={closeText}
        onClose={() => setShowMessage(false)}
        type={type}
      />
      {children}
    </MessagesBoxWrapper>
  )
}

interface MessagesHeaderProps {
  isErrorTypeOfUnavaliabilty: boolean
}

const MessagesBoxWrapper = styled.div<MessagesHeaderProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  background: ${(p) => p.theme.colors.componentsBackground};
  border: 1.5px solid
    ${(p) =>
      p.isErrorTypeOfUnavaliabilty
        ? p.theme.colors.dangerAlertBgBorder
        : p.theme.colors.primary};
  box-sizing: border-box;
  border-radius: 3px;
`
